import { getMarkRange, type MarkViewProps } from '@tiptap/core'

/**
 * Deletes the document range covered by a mark, given the mark view's content host
 * (the element passed to `markViewContentRef`; last child is ProseMirror contentDOM).
 */
export function removeMark(
  markName: string,
  props: MarkViewProps,
  contentHost: HTMLElement
): void {
  const { editor } = props
  const pmContent = contentHost.lastChild
  if (!pmContent) {
    return
  }
  let pos: number
  try {
    pos = editor.view.posAtDOM(pmContent, 0)
  } catch {
    return
  }
  const markType = editor.schema.marks[markName]
  if (!markType) {
    return
  }
  const doc = editor.state.doc
  const clampedPos = Math.max(1, Math.min(pos, doc.content.size))
  const range = getMarkRange(doc.resolve(clampedPos), markType)
  if (!range) {
    return
  }
  editor
    .chain()
    .focus(null, { scrollIntoView: false })
    .deleteRange({ from: range.from, to: range.to })
    .run()
}
